module.exports = __webpack_public_path__ + "static/media/stats.6840f309.svg";